import { IssuedPolicy } from "../objects/issuedPolicy";
import { Policy } from "../objects/policy";
import { QuoteService } from "../services/quoteservice";
import {useDispatch, useSelector} from "react-redux";

const rateCycleReducerFunction = (state : string | null | undefined, action : any) =>{

    switch(action.type) {        
        case "SET_RATECYCLE":
            return (action.payload as string);
            break;
    }
    
    return state === undefined ? "" : state as string;
};

export default rateCycleReducerFunction;